import React, { useState } from "react";
import { Header, useMediaQuery, breakpoints } from "@tvg/design-system";
import { BettingInterest, Willpay } from "@tvg/ts-types/Race";
import Dropdown from "./Dropdown";
import ContentTableWillPays from "./ContentTableWillPays";
import NoWillPaysAvailable from "./NoWillPaysAvailable";
import { WillPaysHeader, WillPaysContainer } from "./styled-components";

interface Props {
  willPays?: Willpay[] | null;
  bettingInterests?: BettingInterest[];
  raceNumber?: string;
  trackName?: string;
}

const WillPays = React.forwardRef<HTMLDivElement, Props>(
  ({ willPays, bettingInterests, raceNumber, trackName }, ref) => {
    const [selectedWillPay, setSelectedWillPay] = useState("0");
    const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

    return (
      <>
        <WillPaysContainer
          ref={ref}
          data-qa-label="container-willPays"
          isEmptyMessage={!(willPays && willPays.length > 0)}
        >
          {willPays && willPays.length > 0 ? (
            <>
              {!isMobile && (
                <WillPaysHeader>
                  <Header
                    tag="h2"
                    qaLabel="willPaysNotAvailable-header"
                    fontFamily="bold"
                    color="grey.900"
                  >
                    Will Pays
                  </Header>
                </WillPaysHeader>
              )}
              <Dropdown
                willPays={willPays}
                selectedWillPay={selectedWillPay}
                changeWillPay={setSelectedWillPay}
                raceNumber={raceNumber}
                trackName={trackName}
              />
              <ContentTableWillPays
                selectedWillPay={selectedWillPay}
                willPays={willPays}
                bettingInterests={bettingInterests}
              />
            </>
          ) : (
            <NoWillPaysAvailable />
          )}
        </WillPaysContainer>
      </>
    );
  }
);

export default WillPays;
